/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Timesheet_Week_NumberInputs */

const fr_timesheet_week_number = /** @type {(inputs: Timesheet_Week_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.week}`)
};

const en_timesheet_week_number = /** @type {(inputs: Timesheet_Week_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.week}`)
};

/**
* | output |
* | --- |
* | "W{week}" |
*
* @param {Timesheet_Week_NumberInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const timesheet_week_number = /** @type {((inputs: Timesheet_Week_NumberInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timesheet_Week_NumberInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_timesheet_week_number(inputs)
	return fr_timesheet_week_number(inputs)
});